import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {VersionService} from './services/version.service';
import {map} from 'rxjs/operators';

@Injectable()
export class VersionGuard implements CanActivateChild {

    constructor(private vers: VersionService) {

    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const url = state.url;

        return this.vers.isChangedVersion().pipe(
            map(res => {
                if(res) {
                    location.href = '/#' + url;
                    location.reload();
                    return false;
                }
                return true;
            })
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/version.guard.ts